import { getToken } from "./authHelper";

export const fetchDocumentIdWithTags = async (
  documentType,
  filters,
  setInUseDocumentIds,
  setMessage
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  var requestBody = null;
  try {
    const impact_georegions_applicable = [filters.country.toLowerCase()];
    const data_source = [documentType.toUpperCase()];
    const document_tags = [filters.year];

    requestBody = {
      impact_georegions_applicable,
      data_source,
      document_tags,
    };

    const response = await fetch(
      `${apiUrl}/document:filter?orderType=DESC&orderBy=publication_timestamp&offset=0&limit=100000&getCount=false`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
          accept: "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    const data = await response.json();
    const document_ids = data.results.records.map((x) => {
      return {
        doc_id: x.id,
        time_stamp: x.publication_timestamp,
        category_theme: x.category_theme,
        public_data_source_url: x.public_data_source_url,
        document_name: x.document_name,
      };
    });
    if (document_ids.length === 0) {
      setMessage("No Document Available for selected Filter");
    }
    if (document_ids.length > 10) {
      let randomIndices = new Set();
      while (randomIndices.size < 10) {
        const randomIndex = Math.floor(Math.random() * document_ids.length);
        randomIndices.add(randomIndex);
      }
      const randomDocumentIds = Array.from(randomIndices).map(
        (index) => document_ids[index]
      );
      setInUseDocumentIds(randomDocumentIds);
    } else {
      setInUseDocumentIds(document_ids);
    }
  } catch (error) {
    console.error("Error in fetching Document Ids:", error);
  } finally {
  }
};

export const fetchDocumentIdsWithDataSource = async (
  selectedDocumentType,
  setDocumentIds
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  var requestBody = null;
  try {
    const data_source = [selectedDocumentType.value.toUpperCase()];

    requestBody = {
      data_source,
    };

    const response = await fetch(
      `${apiUrl}/document:filter?orderType=DESC&orderBy=publication_timestamp&offset=0&limit=100000&getCount=false`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
          accept: "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );

    const data = await response.json();
    const document_ids = data.results.records.map((x) => {
      return {
        doc_id: x.id,
        time_stamp: x.publication_timestamp,
        category_theme: x.category_theme,
        public_data_source_url: x.public_data_source_url,
        document_name: x.document_name,
        impact_georegions_applicable: x.impact_georegions_applicable,
        data_source: x.data_source,
        document_tags: x.document_tags,
      };
    });
    setDocumentIds(document_ids);
  } catch (error) {
    console.error("Error in fetching Document Ids:", error);
  } finally {
  }
};

export const retriveRelevantImages = async (
  pageNumbers,
  documentIds,
  setImageUrls
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const document_id = documentIds ? documentIds[0]["doc_id"] : "";
    const page_number_list = pageNumbers
      ? pageNumbers.map((x) => x.toString())
      : [];

    const response = await fetch(`${apiUrl}/conversation/retrive_image_urls`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ page_number_list, document_id }),
    });
    const data = await response.json();

    setImageUrls(data);
  } catch (error) {}
};

export const retrivePdfUrl = async (documentIds, setPdfUrl) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const document_id = documentIds ? documentIds[0]["doc_id"] : "";

    const response = await fetch(`${apiUrl}/conversation/retrive_pdf_url`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ document_id }),
    });
    const data = await response.json();

    setPdfUrl(data["pdf_url"]);
  } catch (error) {}
};
